export default function getDepartementNumber(cp: string) {
  return cp.startsWith("97") ? cp.substring(0, 3) : cp.substring(0, 2);
}
